import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import ProgressBar from './ProgressBar';

const LoadingScreen = ({message, progressPct}) => (
  <div className="LoadingScreen">
    <div className="LoadingScreen__content">
      <span className="LoadingScreen__message">
        {message}
      </span>
      <div className="LoadingScreen__progressBar">
        <ProgressBar progress={progressPct} />
      </div>
    </div>
  </div>
);

LoadingScreen.propTypes = {
  message: PropTypes.string.isRequired,
  progressPct: PropTypes.number,
};

const mapStateToProps = (state) => ({
  message: state.init.loadingMessage,
  progressPct: state.init.loadingProgressPct,
});

export { LoadingScreen };
export default connect(mapStateToProps)(LoadingScreen);



// WEBPACK FOOTER //
// ./src/components/LoadingScreen.js